<template>
    <v-dialog width="auto">
        <template v-slot:activator="{ props }">
            <div class="mb-2">
                <v-btn  v-bind="props" size="" id="btn-cross-settings" variant="outlined" class=" pa-3"
                style="border-top: 6px solid darkgreen; border-radius: 0;">
                    <v-icon size="x-large" color="yellow" class="">mdi-plus</v-icon>
                </v-btn>
                <v-label class="ml-4" for="btn-cross-settings">
                    Colore e Spessore
                </v-label>
            </div>
        </template>
        <template v-slot:default="{ isActive }">
            <v-card theme="dark">
                <v-card-item>
                    <v-card-title>Colore</v-card-title>
                </v-card-item>
                <!-- <v-card-text class="d-flex justify-center">
                    <v-color-picker v-model="localColor" hide-inputs></v-color-picker>
                </v-card-text> -->

                <v-card-text class="d-flex justify-space-evenly">
                    <v-btn  
                    v-for="c in colorProposed" 
                    :key="c" 
                    variant="flat" 
                    size="x-small" :color="c" @click="color = c" icon
                    :border="color == c"
                    :class="{ selected: color == c, }"
                    >
                
                </v-btn>
                </v-card-text>

                <v-card-item>
                    <v-card-title>Spessore</v-card-title>
                </v-card-item>
                <v-card-text class="d-flex justify-center">
                    <v-slider v-model="width" min="1" max="5" step="1" thumb-label hide-details
                                show-ticks="always"
                                tick-size="4">
                        <template v-slot:append>
                            <span class="text-headline-large font-weight-light pl-10" v-text="width"></span>
                         </template>
                    </v-slider>
                </v-card-text>
                <v-card-actions class="flex-column">
                    <!-- <v-btn  variant="flat" size="large" color="success" @click="applyColor(); isActive.value = false">
                        <v-icon class="mr-2">mdi-content-save</v-icon>
                        Applica</v-btn><br> -->
                    <v-btn  variant="outlined" size="large" color="white" @click="isActive.value = false">
                        <v-icon>mdi-chevron-down</v-icon>
                        Indietro</v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
</template>

  
<script setup>


 
const color = defineModel("color")
const width = defineModel("width")



const colorProposed = [
    "#ffffff",
    "#000000",
    "#ff0000",
    "#00ff00",
    "#ffff00",
    "#00ffff",
    "#ff00ff",
]


</script>

<style scoped>
.v-btn {
    pointer-events: auto;
    margin: .3em;
}

.selected {
    outline: 7px solid grey;

}


.no-uppercase {
     text-transform: unset !important;
}
</style>

